import { TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { LoadingButton } from '@mui/lab';
import { LogInIcon } from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router';

const Login = ({ check }) => {
    const [loading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const user = JSON.parse(window.localStorage.getItem('ts_user'));

    useEffect(() => {
        if (user) {
            navigate('/category')
        }
    }, [user])

    const handleClick = () => {
        setIsLoading(true);
        setError(false);

        axios.post('https://tsetsegtuw.templateapi.xyz/user/login', {
            email: userName,
            password: password,
        })
            .then((e) => {
                console.log('Response:', e.data);
                window.localStorage.setItem('ts_user', JSON.stringify(e.data.user));
                navigate('/');
            })
            .catch((e) => {
                console.error('API Error:', e.response ? e.response.data : e.message);
                setIsLoading(false);
                setError(true);
            });

    }
    return (
        <div className='flex w-screen justify-center items-center'>
            <div className={`h-[40vh] w-[30vw] ${check ? 'bg-white' : 'bg-gray-800'} gap-3 rounded-md justify-center items-center bg-opacity-40 flex flex-col`}>
                <h2 className={`${check ? 'text-[#333]' : 'text-white'} text-2xl font-semibold`}>Цэцэг төв нэвтрэх</h2>
                <TextField value={userName} onChange={(e) => setUserName(e.target.value)} name='email' id="standard-basic" className='w-[15vw]' label="И-Мэйл" variant="standard" />
                <TextField value={password} onChange={(e) => setPassword(e.target.value)} name='password' type='password' id="standard-basic" className='w-[15vw]' label="Нууц үг" variant="standard" />
                <br />
                {error ? <p className='text-red-600'>Таны нууц үг эсвэл и-мэйл буруу байна</p> : null}
                <LoadingButton
                    size="small"
                    onClick={handleClick}
                    endIcon={<LogInIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                >
                    Нэвтрэх
                </LoadingButton>
            </div>
        </div>
    )
}

export default Login
